import {createAction, handleActions} from 'redux-actions';
import {Api} from '../../api/api';
import { logout, onForbidden } from '../account/login';
import {fetchSubmitFormFailed, fetchSubmitFormSuccess} from '../common/submitForm';

//- Actions
export const fetchGetUnreferencedAccreditationRequestsFailed = createAction('FETCH_GET_UNREFERENCED_ACCREDITATION_REQUESTS_FAILED');
export const fetchGetUnreferencedAccreditationRequestsSuccess = createAction('FETCH_GET_UNREFERENCED_ACCREDITATION_REQUESTS_SUCCESS');
export const onGetAccreditationRequestsByDomainsSuccess = (data) => (dispatch, getState) => {
    let isEmpty = data.empty;
    let currentPage = data.number;
    let filterDomain = getAccreditationRequestsFilterDomain(getState());
    let validated = getAccreditationRequestsValidated(getState());
    if ((!isEmpty && currentPage !== 0) || currentPage === 0){
        dispatch(fetchGetUnreferencedAccreditationRequestsSuccess(data));
    } else {
        dispatch(fetchGetAccreditationRequestsByDomains(validated, filterDomain, currentPage - 1));
    }
};

export const onGetAccreditationRequestsFilteredByDomains = (domain) => (dispatch, getState) => {
    let validated = getAccreditationRequestsValidated(getState());
    dispatch(setFilterDomain(domain));
    dispatch(fetchGetAccreditationRequestsByDomains(validated, domain))
};

export const onGetAccreditationRequestsByDomainsByPage = (page) => (dispatch, getState) => {
    let domain = getAccreditationRequestsFilterDomain(getState());
    let validated = getAccreditationRequestsValidated(getState());

    dispatch(fetchGetAccreditationRequestsByDomains(validated, domain, page))
};

export const onGetAccreditationRequestsByDomains = () => (dispatch, getState) =>  {
    let validated = getAccreditationRequestsValidated(getState());

    dispatch(fetchGetAccreditationRequestsByDomains(validated));
};

export const fetchGetAccreditationRequestsByDomains = createAction(
    'FETCH_GET_UNREFERENCED_ACCREDITATION_REQUESTS',
    (validated, domain, page, size) => Api.getAccreditationRequestsByDomains(validated, domain, page, size),
    () => ({
        apiCall: true,
        onSuccess: onGetAccreditationRequestsByDomainsSuccess,
        onFail: fetchGetUnreferencedAccreditationRequestsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const setFilterDomain = createAction('SET_FILTER_DOMAIN');

export const setValidated = createAction('SET_VALIDATED');

export const onChangeUnreferencedAccreditationRequestDomainSuccess = () => (dispatch, getState) => {
    let currentPage = getCurrentPageForAccreditationRequests(getState());
    let filterDomain = getAccreditationRequestsFilterDomain(getState());
    let validated = getAccreditationRequestsValidated(getState());

    dispatch(fetchGetAccreditationRequestsByDomains(validated, filterDomain, currentPage));
    dispatch(fetchSubmitFormSuccess());
};

export const changeUnreferencedAccreditationRequestDomain = (domain, newDomain) => (dispatch) => {
    dispatch(onChangeUnreferencedAccreditationRequest(domain, {domain: newDomain}));
};

export const validateUnreferencedAccreditationRequestDomain = (domain) => (dispatch) => {
    dispatch(onChangeUnreferencedAccreditationRequest(domain, {newDomain: domain, verified: true}));
};

export const onValidateDomain = createAction(
    "FETCH_VALIDATE_DOMAIN",
    (domain, data, bavaManaged) => Api.validateDomain(domain, data, bavaManaged),
    () => ({
        apiCall: true,
        onSuccess: onChangeUnreferencedAccreditationRequestDomainSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onChangeUnreferencedAccreditationRequest = createAction(
    "FETCH_CHANGE_UNREFERENCED_ACCREDITATION_REQUEST_DOMAIN",
    (domain, data) => Api.updateAccreditationRequestByDomain(domain, data),
    () => ({
        apiCall: true,
        onSuccess: onChangeUnreferencedAccreditationRequestDomainSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onRemoveUnreferencedAccreditationRequestDomain = createAction(
    "FETCH_REMOVE_UNREFERENCED_ACCREDITATION_REQUEST_DOMAIN",
    (domain) => Api.removeAccreditationRequestByDomain(domain),
    () => ({
        apiCall: true,
        onSuccess: onChangeUnreferencedAccreditationRequestDomainSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onGetAccreditationRequestsByAGSuccess = (data) => (dispatch, getState) => {
    let isEmpty = data.empty;
    let currentPage = data.number;
    let filterAG = getAccreditationRequestsFilterAG(getState());
    if ((!isEmpty && currentPage !== 0) || currentPage === 0){
        dispatch(fetchGetUnreferencedAccreditationRequestsSuccess(data));
    } else {
        dispatch(fetchGetAccreditationRequestsByAGs(filterAG, currentPage - 1));
    }
};

export const onGetAccreditationRequestsFilteredByAGs = (AG) => (dispatch) => {
    dispatch(setFilterAG(AG));
    dispatch(fetchGetAccreditationRequestsByAGs(AG))
};

export const onGetAccreditationRequestsByAGsByPage = (page) => (dispatch, getState) => {
    let AG = getAccreditationRequestsFilterAG(getState());

    dispatch(fetchGetAccreditationRequestsByAGs(AG, page))
};

export const fetchGetAccreditationRequestsByAGs = createAction(
    'FETCH_GET_UNREFERENCED_ACCREDITATION_REQUESTS',
    (AG, page, size) => Api.getAccreditationRequestsByAGs(AG, page, size),
    () => ({
        apiCall: true,
        onSuccess: onGetAccreditationRequestsByAGSuccess,
        onFail: fetchGetUnreferencedAccreditationRequestsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const setFilterAG = createAction('SET_FILTER_AG');

export const onChangeUnreferencedAccreditationRequestAGSuccess = () => (dispatch, getState) => {
    let currentPage = getCurrentPageForAccreditationRequests(getState());
    let filterAG = getAccreditationRequestsFilterAG(getState());

    dispatch(fetchGetAccreditationRequestsByAGs(filterAG, currentPage));
    dispatch(fetchSubmitFormSuccess());
};

export const onChangeUnreferencedAccreditationRequestAG = createAction(
    "FETCH_CHANGE_UNREFERENCED_ACCREDITATION_REQUEST_DOMAIN",
    (AGId, AGs) => Api.updateAccreditationRequestByAG(AGId, AGs),
    () => ({
        apiCall: true,
        onSuccess: onChangeUnreferencedAccreditationRequestAGSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onRemoveUnreferencedAccreditationRequestAG = createAction(
    "FETCH_REMOVE_UNREFERENCED_ACCREDITATION_REQUEST_DOMAIN",
    (AGs) => Api.removeAccreditationRequestByAG(AGs),
    () => ({
        apiCall: true,
        onSuccess: onChangeUnreferencedAccreditationRequestAGSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const resetAccreditationRequestsData = createAction('RESET_ACCREDITATION_REQUESTS_DATA');

export const fetchGetLastRequestorsOfAccreditationRequestSuccess = createAction('FETCH_GET_LAST_REQUESTORS_OF_ACCREDITATION_REQUEST_DOMAIN_SUCCESS');
export const fetchGetLastRequestorsOfAccreditationRequestFailed = createAction('FETCH_GET_LAST_REQUESTORS_OF_ACCREDITATION_REQUEST_DOMAIN_FAILED');
export const fetchGetLastRequestorsOfAccreditationRequest = createAction(
    "FETCH_GET_LAST_REQUESTORS_OF_ACCREDITATION_REQUEST_DOMAIN",
    (domain) => Api.getLastRequestorsOfAccreditationRequestByDomain(domain),
    () => ({
        apiCall: true,
        onSuccess: fetchGetLastRequestorsOfAccreditationRequestSuccess,
        onFail: fetchGetLastRequestorsOfAccreditationRequestFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

//- State
const initialState = {
    data: null,
    error: null,
    fetching: false,
    currentPage: null,
    totalPages: null,
    filterDomain: null,
    filterAG: null,
    validated: null,
    lastRequestorsData: null,
    fetchingLastRequestors: false,
    errorLastRequestors: null
};

//- Reducers
export default handleActions({
    FETCH_GET_UNREFERENCED_ACCREDITATION_REQUESTS: (state) => {
        return {...state, error: null, fetching: true, currentPage: null, totalPages: null};
    },
    FETCH_GET_UNREFERENCED_ACCREDITATION_REQUESTS_FAILED: (state, action) => {
        return {...state, data: null, error: action.payload, fetching: false, currentPage: null, totalPages: null};
    },
    FETCH_GET_UNREFERENCED_ACCREDITATION_REQUESTS_SUCCESS: (state, action) => {
        return {...state, data: action.payload.content, error: null, fetching: false, currentPage: action.payload.number, totalPages: action.payload.totalPages};
    },
    SET_FILTER_DOMAIN: (state, action) => {
        return {...state, filterDomain: action.payload};
    },
    SET_FILTER_AG: (state, action) => {
        return {...state, filterAG: action.payload};
    },
    SET_VALIDATED: (state, action) => {
        return {...state, validated: action.payload};
    },
    RESET_ACCREDITATION_REQUESTS_DATA: (state) => {
        return {...state, data: null, error: null, validated: null};
    },
    FETCH_GET_LAST_REQUESTORS_OF_ACCREDITATION_REQUEST_DOMAIN: (state) => {
        return {...state, lastRequestorsData: null, errorLastRequestors: null, fetchingLastRequestors: true};
    },
    FETCH_GET_LAST_REQUESTORS_OF_ACCREDITATION_REQUEST_DOMAIN_FAILED: (state, action) => {
        return {...state, lastRequestorsData: null, errorLastRequestors: action.payload, fetchingLastRequestors: false};
    },
    FETCH_GET_LAST_REQUESTORS_OF_ACCREDITATION_REQUEST_DOMAIN_SUCCESS: (state, action) => {
        return {...state, lastRequestorsData: action.payload, errorLastRequestors: null, fetchingLastRequestors: false};
    },
}, initialState);

//- Selectors
export const getUnreferencedAccreditationRequests = state => state.unreferencedAccreditationRequests;

export const loadingUnreferencedAccreditationRequests = state => getUnreferencedAccreditationRequests(state).fetching;

export const getUnreferencedAccreditationRequestsData = state => getUnreferencedAccreditationRequests(state).data;

export const getCurrentPageForAccreditationRequests = state => getUnreferencedAccreditationRequests(state).currentPage;

export const getTotalPagesForAccreditationRequests = state => getUnreferencedAccreditationRequests(state).totalPages;

export const getAccreditationRequestsFilterDomain = state => getUnreferencedAccreditationRequests(state).filterDomain;

export const getAccreditationRequestsFilterAG = state => getUnreferencedAccreditationRequests(state).filterAG;

export const getAccreditationRequestsValidated = state => getUnreferencedAccreditationRequests(state).validated;

export const loadingLastRequestorsOfAccreditationRequest = state => getUnreferencedAccreditationRequests(state).fetchingLastRequestors;

export const getLastRequestorsOfAccreditationRequestData = state => getUnreferencedAccreditationRequests(state).lastRequestorsData;


// WEBPACK FOOTER //
// ./src/reducers/accreditation/unreferencedAccreditationRequests.js